var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAlertFill = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7211 2.50031L18.6597 16.2503C18.8898 16.6489 18.7533 17.1586 18.3547 17.3887C18.228 17.4618 18.0843 17.5003 17.938 17.5003H2.06087C1.60064 17.5003 1.22754 17.1272 1.22754 16.667C1.22754 16.5207 1.26605 16.377 1.33919 16.2503L9.27776 2.50031C9.50785 2.10172 10.0175 1.96516 10.4161 2.19528C10.5428 2.26842 10.648 2.37362 10.7211 2.50031ZM9.1661 13.3337V15.0003H10.8328V13.3337H9.1661ZM9.1661 7.50031V11.667H10.8328V7.50031H9.1661Z",
    fill: "#A90E00"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alert-fill.0a51818c.svg";
export { ForwardRef as ReactComponent };